"use client";

import { useTheme } from "../ThemeProvider";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      offset={140}
      expand={true}
      visibleToasts={3}
      className="toaster group z-2147483647!"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          zIndex: 2147483647,
          marginTop: 'env(safe-area-inset-top)',
          isolation: "isolate",
        } as any
      }
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#0a0a0a] group-[.toaster]:border-black/10 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-[#0a0a0a] dark:group-[.toaster]:text-[#fafafa] dark:group-[.toaster]:border-white/10",
          description: "group-[.toast]:text-[#737373] dark:group-[.toast]:text-[#a1a1aa]",
          actionButton:
            "group-[.toast]:bg-[#0a0a0a] group-[.toast]:text-[#fafafa] dark:group-[.toast]:bg-[#fafafa] dark:group-[.toast]:text-[#0a0a0a]",
          cancelButton:
            "group-[.toast]:bg-[#f4f4f5] group-[.toast]:text-[#737373] dark:group-[.toast]:bg-[#27272a] dark:group-[.toast]:text-[#a1a1aa]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
